export var ACTIVE_AUDIO_NODE_STORE = new WeakSet();
export var AUDIO_NODE_STORE = new WeakMap();
export var AUDIO_GRAPHS = new WeakMap();
export var AUDIO_PARAM_STORE = new WeakMap();
export var AUDIO_PARAM_AUDIO_NODE_STORE = new WeakMap();
export var AUXILIARY_GAIN_NODE_STORE = new WeakMap();
export var BACKUP_NATIVE_CONTEXT_STORE = new WeakMap();
export var CONTEXT_STORE = new WeakMap();
export var DETACHED_ARRAY_BUFFERS = new WeakSet();
export var EVENT_LISTENERS = new WeakMap(); // This clunky name is borrowed from the spec. :-)

export var NODE_NAME_TO_PROCESSOR_DEFINITION_MAPS = new WeakMap();
export var NODE_TO_PROCESSOR_MAPS = new WeakMap();
export var TEST_RESULTS = new WeakMap();